import script from "./sdg-impact-by-company.vue?vue&type=script&lang=ts&setup=true"
export * from "./sdg-impact-by-company.vue?vue&type=script&lang=ts&setup=true"

import "./sdg-impact-by-company.vue?vue&type=style&index=0&id=75f3db7a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f3db7a"]])

export default __exports__